import React from "react";
import useTransitionStore from "../../../state/transitions";
import useCustomizerStore from "../../../state/customizer";
import { defaultControlAngles } from "../../../util/defaultControlAngles";

const InteriorBtn = ({ mode, setDelay }) => {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const setDisplayMode = useTransitionStore((s) => s.setDisplayMode);
  const setModelInHeader = useTransitionStore((s) => s.setModelInHeader);
  const HotspotControls = useTransitionStore((s) => s.HotspotControls);
  const setHotspotControls = useTransitionStore((s) => s.setHotspotControls);
  const setCamIndex = useTransitionStore((s) => s.setCamIndex);
  const setSelectedHotspot = useCustomizerStore((s) => s.setSelectedHotspot);
  const setFilterHotspots = useCustomizerStore((s) => s.setFilterHotspots);
  const filterHotspots = useCustomizerStore((s) => s.filterHotspots);
  const setAzimuthAndPolarAnglesNeedUpdate = useTransitionStore(
    (s) => s.setAzimuthAndPolarAnglesNeedUpdate
  );
  const setTempAzimuthAndPolarAngles = useTransitionStore(
    (s) => s.setTempAzimuthAndPolarAngles
  );
  const setHotspotZoomed = useTransitionStore((s) => s.setHotspotZoomed);
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);
  const setSuspensionMode = useTransitionStore((s) => s.setSuspensionMode);

  return (
    <button
      style={{
        background: DisplayMode === "interior" ? "#EB0A1E" : "#FFF",
        color: DisplayMode === "interior" ? "#fff" : "#000",
        fontWeight: "600",
      }}
      className="interior"
      onClick={() => {
        mode.current = "interior";
        setDisplayMode("interior");
        setModelInHeader(true);
        setCamIndex(2);
        setDelay(600);
        setSelectedHotspot("");
        setSuspensionMode(false);
        setTempAzimuthAndPolarAngles({
          minAzimuthAngle: -Infinity,
          maxAzimuthAngle: Infinity,
          minPolarAngle: -Math.PI * 2,
          maxPolarAngle: Math.PI * 2,
        });
        setAzimuthAndPolarAnglesNeedUpdate(true);
        if (filterHotspots) setFilterHotspots(false);
        if (HotspotControls) {
          setTempAzimuthAndPolarAngles(defaultControlAngles);
          setAzimuthAndPolarAnglesNeedUpdate(true);
          setHotspotControls(false);
          setHotspotZoomed(false);
        }
      }}
    >
      Interior
    </button>
  );
};

export default React.memo(InteriorBtn);
